import {
    GUARDAR_CUESTIONARIO,
    CONSULTAR_CUESTIONARIO,
    OBTENER_FORMULARIOS,
    ASIGNAR_FORMULARIO,
    GUARDAR_EVALUACION,
    CONSULTAR_EVALUACION,
    ACTIVAR_CUESTIONARIO,
    OBTENER_EVALUACIONES,
    RECORRER_EVALUACIONES
} from "../../types";


const EvaluationReducer = (state, action) => {
    switch (action.type) {
        case GUARDAR_CUESTIONARIO:
            return {
                ...state,
                formulario: action.payload,
                msg: action.payload,
                cargando: true
            };
        case OBTENER_FORMULARIOS:
            return {
                ...state,
                formularios: action.payload,
                cargando: false
            }
        case ASIGNAR_FORMULARIO:
            return {
                ...state,
                formulario: action.payload.form,
                matchedId: action.payload.matchedId
            }
        case CONSULTAR_CUESTIONARIO:
            return {
                ...state,
                formulario: action.payload,
                msg: action.payload,
                cargando: true
            };
        case CONSULTAR_EVALUACION:
            return {
                ...state,
                evaluacion: action.payload,
                msg: action.payload,
                cargando: true
            };
        case GUARDAR_EVALUACION:
            return {
                ...state,
                evaluacion: action.payload,
                msg: action.payload,
                cargando: true
            };
        case ACTIVAR_CUESTIONARIO:
            return {
                ...state,
                formulario: action.payload,
                msg: action.payload,
                cargando: true
            };
        case OBTENER_EVALUACIONES:
            return {
                ...state,
                evaluaciones: action.payload,
                cargando: false
            };
        case RECORRER_EVALUACIONES:
            return {
                ...state,
                formulario: action.payload,
                evaluacion: action.payload
            }
        default:
            return state;
    }
}

export default EvaluationReducer;